import { useState } from 'react'

import lock from 'assets/image/icons/svg/lock.svg'
import InformationalTip from 'components/molecules/InformationalTip'
import { CONSTS } from 'config/objectConst'
import { useAppSelector } from 'shared/hooks'
import { appSelectors } from 'redux/reducers/app'

import type { WorkSpace } from '../../'

import './style.scss'

type Key = keyof Omit<WorkSpace.Stats, 'withdrawn_limit'>

const KEYS: {
	key: Key
	label: string
	max?: Key
}[] = [
	{
		key: 'invitations_sent',
		label: 'Sent invitations',
		max: 'invitations_limit'
	},
	{
		key: 'invitations_accepted_count',
		label: 'Accepted invitations'
	},
	{
		key: 'withdrawn_count',
		label: 'Withdrawn invitations'
	},
	{
		key: 'messages_count',
		label: 'Sent messages',
		max: 'messages_limit'
	},
	{
		key: 'replied_count',
		label: 'Replied'
	},
	{
		key: 'react_on_post_count',
		label: 'Likes',
		max: 'react_on_post_limit'
	},
	{
		key: 'follow_count',
		label: 'Followed',
		max: 'follow_limit'
	}
]

function getWidth(value: number, max: number) {
	if (value === 0 && max === 0) {
		return 0
	}

	// legacy logic
	if (max <= value) {
		return 100
	}

	max ||= value + 1
	return (value / max) * 100
}

export const Performed = ({
	limit = false,
	statistics
}: {
	limit?: boolean
	statistics?: WorkSpace.Stats
}) => {
	const persona = useAppSelector(appSelectors.persona)
	const [isTipsVisible, setIsTipsVisible] = useState(false)

	const showLockIcon =
		persona?.exceedLinkedInInvitationsLimit &&
		KEYS.some(({ label }) => label === 'Sent invitations')

	return (
		<>
			{isTipsVisible && (
				<div className='backdrop' onClick={() => setIsTipsVisible(false)} />
			)}
			<ul className='performed'>
				{KEYS.map(({ key, label, max }) => {
					const value = statistics?.[key] || 0

					let itemMaxV: '~' | number = '~'

					if (max && limit && statistics) {
						itemMaxV = statistics[max]
					}

					const maxValue = itemMaxV === '~' ? 50 : Number(itemMaxV)

					return (
						<li className='performed-item' key={key}>
							<div className='performed-data'>
								<div>{label}</div>

								<div className='flex-container'>
									{label === 'Sent invitations' && showLockIcon && (
										<>
											<img
												src={lock}
												alt='iconStop'
												className='clock-icon'
												onClick={() => setIsTipsVisible(true)}
											/>
											{isTipsVisible && (
												<InformationalTip
													centered={!limit ? '-240px' : undefined}
													arrowPosition={limit ? '38px' : '275px'}
													onClose={() => setIsTipsVisible(false)}
													data={CONSTS.TIPS['n4.3']}
													maxWidth='280px'
												/>
											)}
										</>
									)}
									<div>
										<span>{value}</span>/{itemMaxV || 0}
									</div>
								</div>
							</div>
							<div className='performed-progress'>
								<div
									className='performed-bar'
									style={{
										width: `${getWidth(value, maxValue)}%`
									}}
								>
									&nbsp;
								</div>
							</div>
						</li>
					)
				})}
			</ul>
		</>
	)
}
